import { SVGProps } from 'react';
const IconMapOneByOneHorizontal = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} viewBox='0 0 24 24' fill='none' {...props}>
    <path
      fill='currentColor'
      fillOpacity={0.4}
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M21.316 6.138c.327.642.327 1.482.327 3.162v5.4c0 1.68 0 2.52-.328 3.162a3 3 0 0 1-1.31 1.311c-.642.327-1.482.327-3.162.327h0H12v-15h4.843c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311Z'
    />
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M2.357 9.3c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.31-1.311C4.638 4.5 5.478 4.5 7.158 4.5h9.686c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.31 1.311c.328.642.328 1.482.328 3.162v5.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311c-.642.327-1.482.327-3.162.327H7.157c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.31-1.311c-.328-.642-.328-1.482-.328-3.162V9.3Z'
    />
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M7.18 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z'
    />
  </svg>
);
export default IconMapOneByOneHorizontal;
